import { component } from "preact";
import { css } from "emotion";

const UniqueText = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  maxWidth = "none",
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  fontWeight = 400,
  fontSize = 20,
  fontSizeMobile = 16,
  center,
  children
}) => {
  const styleObj = {
    fontWeight: fontWeight,
    fontSize: fontSize,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    "@media(max-width: 600px)": {
      fontSize: fontSizeMobile,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    }
  };

  if (center) {
    styleObj.marginRight = "auto";
    styleObj.marginLeft = "auto";
  }

  const style = css(styleObj);

  return <p className={style}>{children}</p>;
};

export default UniqueText;
